import React, { useState, useEffect } from "react";
import CommonFunctions from "../utils/helpers/CommonFunctions";

const AttributeSelectorNew = ({passengersCount, attributesOptions, savedData = [], onChange}) => {

  const [selections, setSelections] = useState({});
  const [passengerTypeLabel] = useState(["PCA", "Guest"])

  const [totalAdults] = useState(passengersCount.passenger ?? 0);
  const [totalChildren] = useState(passengersCount.children ?? 0);

  const [rowItems, setRowItems] = useState([]);

  useEffect(() => {

    return () => {
    
    };
  }, [])

  useEffect(() => {
    const newSelections = {};
    rowItems.forEach(row => {
      newSelections[row.key] = {
        key: row.key,
        selectedLabel: row.selectedLabel,
        selectedAttribute: row.selectedAttribute,
        type: row.type,
        index: row.index,
        childrenRowIndex: row.childrenRowIndex,
      };
    });
  
    setSelections(newSelections);
    onChange?.(newSelections);
  }, [rowItems])
 
  const getDefault = () => {
    return (
      attributesOptions.find(opt =>
        ['amb', 'ambu', 'ambulatory'].some(keyword =>
          opt.value?.toLowerCase().startsWith(keyword)
        )
      )?.key || ''
    );
  };
  

  useEffect(() => {
    // if (savedData && Object.keys(savedData).length > 0) {
    //   const initialSelections = {};
    //   Object.values(savedData).forEach(item => {
    //     initialSelections[item.key] = {
    //       selectedLabel: item.selectedLabel ?? 'Guest',
    //       selectedAttribute: item.selectedAttribute ?? '',
    //       key : item.key,
    //       index : item.index,
    //       childrenRowIndex: item.childrenRowIndex,
    //       type: item.type
    //     };
    //   });
    //   setSelections(initialSelections);
    // }

    if (savedData && Object.keys(savedData).length > 0) {
      const initialSelections = {};
    
      Object.entries(savedData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item && item.key) {
              initialSelections[item.key] = {
                selectedLabel: item.selectedLabel ?? 'Guest',
                selectedAttribute: item.selectedAttribute ?? '',
                key: item.key,
                index: item.index,
                childrenRowIndex: item.childrenRowIndex,
                type: item.type
              };
            }
          });
        } else if (typeof value === 'object' && value !== null) {
        
          if (value.key) {
            initialSelections[value.key] = {
              selectedLabel: value.selectedLabel ?? 'Guest',
              selectedAttribute: value.selectedAttribute ?? '',
              key: value.key,
              index: value.index,
              childrenRowIndex: value.childrenRowIndex,
              type: value.type
            };
          }
        }
      });
    
      setSelections(initialSelections);
    }
    
  }, [savedData]);
  

  useEffect(() => {
    const rows = [];
    const savedArray = savedData ? Object.values(flattenRows(savedData)) : [];
    
    let isValidToIterate = true;
    try {
      JSON.stringify(savedArray)
    } catch (error) {
      
    }

    if (totalAdults >= 1) {
      const savedRow = savedArray.find(r => r?.type?.toLowerCase() === 'primary') || {};
      
      let attribute = savedRow.selectedAttribute ?? savedRow.Attributes ?? getDefault();
      const generatedKey = savedRow.key || CommonFunctions.GenerateUUID();
      rows.push({
        key: generatedKey,
        type: 'primary',
        selectedLabel: 'Primary',
        index: savedRow.index ?? 0,
        childrenRowIndex: -1,
        selectedAttribute: attribute//savedRow.selectedAttribute ?? getDefault()
      });
    }
  
    if (totalAdults > 1) {
      for (let i = 1; i < totalAdults; i++) {
        const savedRow = savedArray.find(r => (r?.type === 'adult' && r.index === i)) || {};
        let attribute = savedRow.selectedAttribute ?? savedRow.Attributes ?? getDefault();
        const generatedKey = savedRow.key || CommonFunctions.GenerateUUID();
  
        rows.push({
          key: generatedKey,
          type: 'adult',
          selectedLabel: savedRow.selectedLabel ?? 'Guest',
          index: i,
          childrenRowIndex: -1,
          selectedAttribute: attribute//savedRow.selectedAttribute ?? getDefault()
        });
      }
    }
  
    setRowItems(prev => [...prev, ...rows]);
  }, [passengersCount?.passenger]);

  useEffect(() => {
    const rows = [];
    const savedArray = savedData ? Object.values(flattenRows(savedData)) : [];

    for (let i = 0; i < totalChildren; i++) {
      const savedRow = savedArray.find(r => r?.type?.toLowerCase() === 'children'&& r.childrenRowIndex === i) || {};
      let attribute = savedRow.selectedAttribute ?? savedRow.Attributes ?? getDefault();
      const generatedKey = savedRow.key || CommonFunctions.GenerateUUID();

      rows.push({
        key: generatedKey,
        type: 'children',
        selectedLabel: savedRow.selectedLabel ?? `Child`,
        index: i,
        childrenRowIndex: i,
        selectedAttribute: attribute//savedRow.selectedAttribute ?? getDefault()
      });
    }
  
    setRowItems(prev => {
      const nonChildrenRows = prev.filter(r => r?.type !== 'children');
      return [...nonChildrenRows, ...rows];
    });
  }, [passengersCount?.children]);

  const GetColorHueLightness = (type, index) => {
    if(index == undefined || index == -1 ){ index = 1;}

    let hue = 100;
    let lightness = 90 - index * 3;
    try {
      if(type == "children"){
        hue = 200; 
        lightness = 90 - index * 3;
      }
      else if(type == "primary"){
        hue = 30; 
        lightness = 80;
      }
    } catch (error) {
      return {hue, lightness}  
    }

    return {hue, lightness}
  }

  const handleChange = (rowKey, type, value) => {
 
    const row = rowItems.find(r => r?.key === rowKey);
    if (!row) return;
  
    const updatedSelections = {
      ...selections,
      [rowKey]: {
        ...row, 
        ...(selections[rowKey] || {}),
        [type]: value
      }
    };
  
    setSelections(updatedSelections);
    onChange?.(updatedSelections);
  };

  const flattenRows = (savedData) => {
    const rows = [];
  
    Object.entries(savedData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // Handle arrays (PCA, Guests, Children)
        value.forEach((v, i) =>
          rows.push({
            ...v,
           // type: key,       // keep track of source (PCA, Guest, Child)
           // index: i
          })
        );
      } else if (typeof value === "object" && value !== null) {
        // Handle single object (Primary)
        rows.push({
          ...value,
         // type: key,         // "Primary"
          //index: 0
        });
      }
    });
  
    return rows;
  };
  
  

  return (
    <div className="p-1 space-y-4">
      {rowItems.map((item) => {
        const { key, type, index, childrenRowIndex } = item;
        const { selectedLabel = passengerTypeLabel[1], selectedAttribute = '' } = selections[key] || {};

        const { hue, lightness } = GetColorHueLightness(type === 'primary' ? 'primary' : 'children', index);
        const bgColor = `hsl(${hue}, 60%, ${lightness}%)`;

        return (
          <div key={key} style={{ display: 'inline-flex', marginBottom: '5px' }}>
            
            {type === 'primary' || type === 'children' ? (
              <label
                className="text-right"
                style={{ width: "40%", backgroundColor: bgColor, padding: "4px 8px", borderRadius: "4px", fontWeight: "semibold" }}
              >
                {type === 'primary' ? 'Primary' : `Child ${childrenRowIndex}`}
              </label>
            ) : 
            (  
              <select
                style={{ width: "40%", background: "#d1e2d1" }}
                className="border border-gray-300 rounded px-3 py-1"
                value={selectedLabel}
                onChange={(e) => handleChange(key, 'selectedLabel', e.target.value)}
              >
                {passengerTypeLabel.map((option, i) => (
                  <option key={i} value={option}>{option}</option>
                ))}
              </select>
            )}
            
            <select
              style={{ width: "60%", marginLeft: "5px" }}
              className="border border-gray-300 rounded px-3 py-1"
              value={selectedAttribute}
              onChange={(e) => handleChange(key, 'selectedAttribute', e.target.value)}
            >
              {attributesOptions.map((option, i) => (
                <option key={i} value={option.key}>{option.value}</option>
              ))}
            </select>
          </div>
        );
      })}
    </div>
  );
};

export default AttributeSelectorNew;
